import React from 'react';
import { Message } from 'rsuite';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const StyledMessage = styled(Message)`
  margin: 20px;
`;

const AccessDenied = ({ title, description, ...props }) => (
  <StyledMessage
    {...props}
    showIcon
    type="error"
    title={title}
    description={description}
  />
);

AccessDenied.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string
};

AccessDenied.defaultProps = {
  title: 'Access Denied',
  description: 'Sorry, you do not have enough permission to view this content.'
};

export default AccessDenied;
